import type { ColorSettings } from '@/@core/models/api/configResponse';

export async function applyCustomColors(colorSettings: ColorSettings) {
  if (colorSettings) {
    for (const [key, value] of Object.entries(colorSettings)) {
      document.documentElement.style.setProperty(`--un-preset-theme-colors-${key}`, value);
    }
  }
}
